import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {PasswordsService} from '../passwords.service';
import range from 'lodash-es/range';

@Component({
  selector: 'password-strength-indicator',
  templateUrl: './password-strength-indicator.component.html',
  styleUrls: ['./password-strength-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordStrengthIndicatorComponent implements OnInit, OnChanges {

  @Input() password: string;

  strength: number;
  maxStrength: number;
  pwRange: number[];
  tipOpen = false;

  constructor(private Passwords: PasswordsService) {
  }

  ngOnInit() {
    this.maxStrength = this.Passwords.getMaxStrength();
    this.pwRange = range(0, this.maxStrength);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.strength = this.Passwords.measureStrength(this.password);
  }
}
